import type { UserApi } from "../../api/UserApi";
import type { CreateUserStaff } from "../../generated/dto/CreateUserStaff";
import type { DeleteUserStaff } from "../../generated/dto/DeleteUserStaff";
import type { RoleAssignmentFetchOptions } from "../../generated/dto/RoleAssignmentFetchOptions";
import type { RoleAssignmentStaff } from "../../generated/dto/RoleAssignmentStaff";
import type { UpdateUserStaff } from "../../generated/dto/UpdateUserStaff";
import type { UserPermissionFetchOptions } from "../../generated/dto/UserPermissionFetchOptions";
import type { UserPermissionStaff } from "../../generated/dto/UserPermissionStaff";
import type { UserStaff } from "../../generated/dto/UserStaff";
import type { UserStaffFetchOptions } from "../../generated/dto/UserStaffFetchOptions";

export class UserFrontendService {
  constructor(private readonly api: UserApi) {}
  async getUserStaff(id: number, options?: UserStaffFetchOptions): Promise<UserStaff> {
    return this.api.getUserStaff(id, options)
  }
  async createUserStaff(source: CreateUserStaff): Promise<UserStaff> {
    return this.api.createUserStaff(source)
  }
  async updateUserStaff(source: UpdateUserStaff): Promise<UserStaff> {
    return this.api.updateUserStaff(source)
  }
  async deleteUserStaff(source: DeleteUserStaff): Promise<void> {
    return this.api.deleteUserStaff(source)
  }
  async getUserStaffRoleAssignments(id: number, options?: RoleAssignmentFetchOptions): Promise<Array<RoleAssignmentStaff>> {
    return this.api.getUserStaffRoleAssignments(id, options)
  }
  async getUserStaffPermissions(id: number, options?: UserPermissionFetchOptions): Promise<Array<UserPermissionStaff>> {
    return this.api.getUserStaffPermissions(id, options)
  }
  async currentUserStaff(): Promise<UserStaff> {
    return this.api.currentUserStaff()
  }
}
